"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERC20ABI = exports.WrappedTokenABI = void 0;
const WrappedToken_1 = __importDefault(require("./WrappedToken"));
const ERC20_1 = __importDefault(require("./ERC20"));
exports.WrappedTokenABI = WrappedToken_1.default;
exports.ERC20ABI = ERC20_1.default;
//# sourceMappingURL=index.js.map